import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    beforeEnter: () => {
      const userStore = useUserStore()
      if (!userStore.isAuthenticated) {
        return { name: 'Login' }
      }
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    beforeEnter: () => {
      const userStore = useUserStore()
      if (userStore.isAuthenticated) {
        return { name: 'Home' }
      }
    }
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: () => import('@/views/Login.vue'), // Reuse Login component while processing
    beforeEnter: async (to) => {
      const userStore = useUserStore()
      
      // Extract JWT token from URL query parameters
      const token = to.query.token
      
      if (token) {
        // Store the token
        userStore.handleCallback(token)
        
        // Fetch user data before redirecting
        try {
          await userStore.detect()
          // Redirect to home
          return { name: 'Home' }
        } catch (err) {
          console.error('Failed to fetch user data:', err)
          return { name: 'Login' }
        }
      } else {
        // No token, redirect to login with error
        return { name: 'Login' }
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
